var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBaby = function SvgIconBaby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.875 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8.683 15.197a1 1 0 0 1 1.386-.28 3.49 3.49 0 0 0 3.862 0 1 1 0 1 1 1.107 1.666 5.49 5.49 0 0 1-6.076 0 1 1 0 0 1-.28-1.386"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.01 2C17.528 2.005 22 6.48 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12c0-5.52 4.473-9.995 9.992-10m-.338 3.836c.133-.501.38-1.148.838-1.821a8 8 0 1 1-2.39.211 8 8 0 0 0-.38 1.094 7 7 0 0 0-.192.994 5 5 0 0 0-.03.389v.045s0 .002 1 .002h-1a2.5 2.5 0 0 0 2.5 2.5h.007c.43-.003.852-.114 1.229-.323a1 1 0 1 0-.972-1.748.6.6 0 0 1-.267.071.5.5 0 0 1-.497-.495v.002-.002l.002-.036q.002-.054.015-.178c.019-.163.057-.407.137-.705m-.154.919V6.75v.004m.497.495H12v1l-.007-1zm-1.497-.5h1z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBaby;